import { Page, Layout, Card, Button, Box, Text } from '@shopify/polaris';
import AppDataTable from '#client/components/AppDataTable/AppDataTable.jsx';
import InventoryAdjustmentTableConfig from './InventoryAdjustmentTableConfig.jsx';
import { hasPermission } from '#client/utils/helpers';
import { useContext } from 'react';
import { SessionContext } from '#client/contexts/SessionContext.jsx';
import ActivityLog from '#client/components/ActivityLog';
import { useNavigate } from 'react-router';

function InventoryAdjustmentsPage() {
    const { currentUser } = useContext(SessionContext);
    const navigate = useNavigate();

    let createNewAdjustmentButton;
    if (hasPermission(currentUser, 'adjCreate')) {
        createNewAdjustmentButton = (
            <Button variant="primary" onClick={() => navigate('/inventory-adjustments/new')}>
                Create New Adjustment
            </Button>
        );
    }

    return (
        <>
            <Page fullWidth primaryAction={createNewAdjustmentButton}>
                <Layout>
                    <Layout.Section>
                        <Card>
                            <Box paddingBlock="400">
                                <Text variant="headingLg">Inventory Adjustments</Text>
                            </Box>
                            <AppDataTable DataTableConfig={InventoryAdjustmentTableConfig} />
                        </Card>
                    </Layout.Section>
                    <Layout.Section>
                        <Card>
                            <ActivityLog objectType="InventoryAdjustment" />
                        </Card>
                    </Layout.Section>
                </Layout>
            </Page>
        </>
    );
}
export default InventoryAdjustmentsPage;
